import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, Modal } from 'antd';

export const LastFourSsnModal = ({
  visible,
  handleSubmit,
  onClose,
  profileName,
  submitLoading,
}) => {
  const [form] = Form.useForm();

  return (
    <>
      <Modal
        className="LastFourSsnModal"
        title="Add Last Four SSN"
        visible={visible}
        footer={[
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={form.submit}
            loading={submitLoading}
          >
            Save
          </Button>,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item
            label={`Last four (4) digits of ${profileName}'s SSN`}
            name="lastFourSsn"
            rules={[
              {
                required: true,
                pattern: /\d{4}$/,
                message: 'Enter the last 4 SSN digits.',
              },
            ]}
          >
            <Input size="large" maxLength={4} placeholder="xxxx" />
          </Form.Item>
        </Form>
      </Modal>
      <style jsx>{`
        :global(.LastFourSsnModal .ant-modal-footer) {
          text-align: right;
        }
      `}</style>
    </>
  );
};

LastFourSsnModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  profileName: PropTypes.string.isRequired,
  submitLoading: PropTypes.bool.isRequired,
};
